export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    description: '',
    qty: 1,
    conversion_qty: 1,    
    item_edit: 0
}

export let dataProps = {
    id: 0,
    store_id: null,
    challan_number: null,
    transaction_date: new Date(), 
    additional_notes: '', 
    source_item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    item_edit: false,
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/inventorySeparation/properties.js